var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.isEditing ? _c('span', [_vm.hasPermission('triggers.edit') ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip",
      value: `Bewerken`,
      expression: "`Bewerken`"
    }],
    staticClass: "p-0 m-0 mx-2 float-right",
    attrs: {
      "variant": "link",
      "size": "sm"
    },
    on: {
      "click": _vm.openEditMode
    }
  }, [_c('small', [_c('font-awesome-icon', {
    staticClass: "text-info",
    attrs: {
      "icon": "pencil"
    }
  })], 1)]) : _vm._e(), _vm._t("default", function () {
    return [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.nl2br(_vm.value))
      }
    })];
  })], 2) : _c('span', [_c('b-textarea', {
    ref: "editTextarea",
    staticClass: "d-inline-block",
    staticStyle: {
      "width": "calc(100% - 40px)"
    },
    attrs: {
      "size": "sm",
      "autofocus": "",
      "disabled": _vm.isSaving
    },
    on: {
      "focus": _vm.resizeTextarea
    },
    model: {
      value: _vm.editableValue,
      callback: function ($$v) {
        _vm.editableValue = $$v;
      },
      expression: "editableValue"
    }
  }), _c('div', {
    staticClass: "float-right",
    staticStyle: {
      "width": "40px"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip",
      value: `Opslaan`,
      expression: "`Opslaan`"
    }],
    staticClass: "p-0 my0 mx-2",
    attrs: {
      "variant": "link",
      "disabled": _vm.isSaving
    },
    on: {
      "click": _vm.saveAndCloseEditMode
    }
  }, [_c('small', [_c('font-awesome-icon', {
    staticClass: "text-success",
    attrs: {
      "icon": "floppy-disk"
    }
  })], 1)]), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip",
      value: `Annuleren`,
      expression: "`Annuleren`"
    }],
    staticClass: "p-0 my0 mx-2",
    attrs: {
      "variant": "link",
      "disabled": _vm.isSaving
    },
    on: {
      "click": _vm.cancelEditing
    }
  }, [_c('small', [_c('font-awesome-icon', {
    staticClass: "text-danger",
    attrs: {
      "icon": "ban"
    }
  })], 1)])], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }